"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_1 = require("./styled");
exports.Badge = (0, react_1.forwardRef)((props, ref) => (0, jsx_runtime_1.jsx)(styled_1.StyledBadge, Object.assign({ ref: ref }, props)));
exports.Badge.displayName = 'Badge';
exports.default = exports.Badge;
